export type NormBand = {
  id: string;
  label: string;
  unit: string;
  low: number;
  high: number;
  note: string;
};

/* General reference bands, not diagnostic measures. Bundled statically so
   comparisons work with zero network requests. Every note says so plainly —
   this is training feedback, not a medical claim. */
export const NORMS: NormBand[] = [
  {
    id: "phonation-time",
    label: "Max phonation time — adult reference",
    unit: "seconds",
    low: 15,
    high: 25,
    note: "A commonly cited general adult range for a single sustained breath in voice-training material. This is a rough training reference, not a diagnostic measure — if you're consistently well below it and concerned, talk to a speech-language professional.",
  },
  {
    id: "conversational-wpm",
    label: "Comfortable conversational pace",
    unit: "wpm",
    low: 110,
    high: 150,
    note: "Typical relaxed conversational speaking pace. This app's full-speed twister targets sit inside or just past this band on purpose.",
  },
];
